import { createContext, useContext } from 'react';
import type { IToast } from './useToasts';

/** Put one toast on the app's shared stack. */
export type PushToast = (toast: Omit<IToast, 'id'>) => void;

/**
 * The app's shared toast queue, provided once at the app shell by
 * `ToastProvider`. Null outside one — and `useToast` refuses that, so a
 * surface can never be mounted somewhere its failures report to nobody.
 */
export const ToastContext = createContext<PushToast | null>(null);

/**
 * The shared queue's `push`. A write's failure is reported through this, not
 * through a prop a host may forget to pass: every surface reaches the same
 * stack wherever it is mounted (the Scheduler, the Activities drawer, the
 * dashboard's alert drawer).
 */
export function useToast(): PushToast {
  const push = useContext(ToastContext);
  if (!push) throw new Error('useToast must be used inside a ToastProvider');
  return push;
}
